export default {
  alias      : 'tramite_plantilla',
  route      : '/tramite/plantillaC',
  hash       : false,
  store      : false,
  name       : 'plt_nombre',
  key        : 'id',
  selectable : false,
  default    : {
    id                : null,
    plt_nombre        : null,
    plt_plantilla     : '',
    plt_datos         : [],
    plt_derivaciones  : [],
    plt_referencias   : null,
    plt_idadmin       : null,
    plt_iddependencia : null,
    created_at        : null,
    updated_at        : null,
  }
}
  